import { render, staticRenderFns } from "./activity_detail.vue?vue&type=template&id=370aa4af&"
import script from "./activity_detail.vue?vue&type=script&lang=ts&"
export * from "./activity_detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports